import './bootstrap';
import '../css/app.css';

import { createApp, h } from 'vue';
import { createInertiaApp, router } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';

import axios from "axios";

axios.defaults.withCredentials = true;

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

// Cuando la sesión expira a mitad de una acción, la respuesta del servidor
// termina siendo la página de Login como JSON plano sin el header que
// Inertia necesita para reconocerla como una visita válida — Inertia lo
// reporta como "invalid" en vez de navegar solo. En vez de mostrar ese
// error, hacemos una recarga completa a donde el servidor haya redirigido
// (normalmente /login), que sí carga la página bien.
router.on('invalid', (event) => {
    event.preventDefault();
    window.location.href = event.detail.response?.data?.url || window.location.href;
});

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
